/** @format */

import React from 'react';
import PropTypes from 'prop-types';
import TableBase from './TableBase';
import TableBaseReadOnly from './TableBaseReadOnly';

class Table extends React.Component {
  static propTypes = {
    /** Pre-defined custom styles to override TableBase */
    styleType: PropTypes.string,
    /** Classname to be applied to <Table> */
    className: PropTypes.string,
    /** Styles to be applied to component */
    classes: PropTypes.object,
    /** Data that will be used to generate table columns */
    columns: PropTypes.PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.string.isRequired,
        displayText: PropTypes.string.isRequired,
        visible: PropTypes.bool,
        sticky: PropTypes.bool,
        sortable: PropTypes.bool,
      }),
    ).isRequired,
    /** Data that will be used to generate table rows */
    rows: PropTypes.array.isRequired,
    /** Read Only mode will force table to ignore renderComponent per columns and display cell value */
    readOnly: PropTypes.bool,
    /** Hide header */
    hideHeader: PropTypes.bool,
    /** Page for the table to open at */
    page: PropTypes.number,
    /** Enable/disable table pagination */
    pagination: PropTypes.bool,
    /** If provided, the total number of rows for the table */
    totalRows: PropTypes.number,
    /** If provided, the total number of rows per page */
    rowsPerPage: PropTypes.number,
    /** Server side mode means that the Table component will not handle pagination/sort. Useful for depedency on API's */
    serverSide: PropTypes.bool,
    /** Populate first column with selectable radio button */
    selectableRows: PropTypes.bool,
    /** Provide custom footer to display with the Table */
    footer: PropTypes.func,
    /** Callback function to get reference to internal setTableModel() method */
    setTableModel: PropTypes.func,
    /** Callback function to get reference to internal updateColumnValue() method */
    updateColumn: PropTypes.func,
    /** Callback function to get reference to internal updateModelValue() method */
    updateModel: PropTypes.func,
    /**
     * Callback function for table updates. fn(actionType: string, tableState: object)
     * tableState enum: ('rowClick', 'cellClick', 'pageChange', 'colSort', 'rowsSelected')
     */
    onTableChange: PropTypes.func,
    // Message for when no table data available
    noTableDataMsg: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.object
    ]),
    /**
     * Use to vertical mode true change vertical by defaul is false show horizontal
     */
    showVerticalMode: PropTypes.bool,
    /* Skip rules to display cell */
    hardDisplay: PropTypes.bool,
  };

  getStyles = type => {
    switch (type) {
      case 'landingPage':
        return {
          TableBodyCell: {
            rootExtra: {
              cursor: 'pointer',
            },
          },
        };

      case 'dashboard':
        return {
          // TableBodyCell: {
          //   root: {
          //   }
          // }
        };
      default:
        return {};
    }
  };

  render() {
    const { styleType, ...otherProps } = this.props;
    const styles = this.getStyles(styleType);

    if (this.props.showVerticalMode === true) {
      return <TableBaseReadOnly styleOverrides={styles} {...otherProps} />;
    } else {
      return <TableBase styleOverrides={styles} {...otherProps} />;
    }
  }
}

export default Table;
